import moment from 'moment';
import config from 'config';

// how many days behind and ahead we want for sitemap fixtures/racecards
const {
  SITEMAP_DAYS_BEHIND,
  SITEMAP_DAYS_AHEAD
} = config.sitemap;

// returns array of y days into the future
export function nDayArrFactoryForwards() {
  const dateArray = [];
  const startDate = moment();

  // initial day
  dateArray.push(startDate.format('YYYY-MM-DD'));
  // loop
  for (let x = 0; x < SITEMAP_DAYS_AHEAD; x++) {
    dateArray.push(startDate.add(1 , 'days').format('YYYY-MM-DD'));
  }

  return dateArray;
}

// returns array of x days into the past
export function nDayArrFactoryBackwards() {
  const dateArray = [];
  const startDate = moment().subtract(SITEMAP_DAYS_BEHIND , 'days');

  // initial day
  dateArray.push(startDate.format('YYYY-MM-DD'));
  // loop
  for (let x = 0; x < SITEMAP_DAYS_AHEAD; x++) {
    dateArray.push(startDate.add(1 , 'days').format('YYYY-MM-DD'));
  }

  return dateArray;
}

// returns array of past x days, today, and y days into the future
export function nDayArrFactoryBoth() {
  const dateArray = [];
  const startDate = moment().subtract(SITEMAP_DAYS_BEHIND , 'days');

  // initial day
  dateArray.push(startDate.format('YYYY-MM-DD'));
  // loop
  for (let x = 0; x < SITEMAP_DAYS_BEHIND + SITEMAP_DAYS_AHEAD; x++) {
    dateArray.push(startDate.add(1 , 'days').format('YYYY-MM-DD'));
  }

  return dateArray;
}

export function stripTZD(time) {
  const trailingNumericTZD = /\+[0-9]{2}(:[0-9]{2})?$/;

  return time && `${time}`.replace(trailingNumericTZD, "");
}


// WEBPACK FOOTER //
// ./utils/sitemapUtils.js